// extracted by mini-css-extract-plugin
export default {"root":"style_root__DTEbk","image":"style_image__8tSjO","data":"style_data__CoCtW","title":"style_title__HZwBq","message":"style_message__J9g3K"};